import React from 'react';

import NewWheelchairPt1 from './NewWheelchairPt1';
import NewWheelchairPt2 from './NewWheelchairPt2';
import NewWheelchairPt3 from './NewWheelchairPt3';
import NewWheelchairPt4 from './NewWheelchairPt4';
import NewCoursePage from './NewCoursePage';

const NewWheelchair = props => (
  <NewCoursePage {...props} videoLink="UOpMeu_oQbM" header={"Wheelchair and Device Handling"}>
    <NewWheelchairPt1 />
    <NewWheelchairPt2 />
    <NewWheelchairPt3 />
    <NewWheelchairPt4 />
  </NewCoursePage>
);

export default NewWheelchair;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewWheelchair.js